<form [formGroup]="form">
  <app-input-group>
    <label appLabel>
      {{ 'meteringpoint.identification' | translate }}
    </label>
    <input type="text" appInput readonly formControlName="meteringPointIdentification">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'date.validFrom' | translate }}</label>
    <input appInputDate [defaultDate]="false" formControlName="validFrom">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'date.validTo' | translate }}</label>
    <input appInputDate [defaultDate]="false" formControlName="validTo">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.meter.meternumber' | translate}}</label>
    <select appSelect formControlName="meterNumber">
      <option value="null" selected disabled>{{ 'common.select' | translate }} {{ 'common.meter' | translate }}</option>
      @for (item of meterList; track item.id) {
        <option [value]="item.id">
          {{ item.serialNumber ? `Serienummer: ${item.serialNumber}` : '' }} {{ item.alternateMeterNumber ? `- Placering: ${item.alternateMeterNumber}` : '' }} {{ item.meterNumber ? `- Målernummer: ${item.meterNumber}` : 'Ingen målernummer' }}
        </option>
      }
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.meter.serialnumber' | translate}}</label>
    <input type="text" appInput formControlName="serialNumber" readonly placeholder="Målerserienummer">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'common.quadrant' | translate  }}</label>
    <app-alert type="info" [closeable]="false">
      {{ 'htxMeterModal.quadrantSyncWarning' | translate }}
    </app-alert>
    <input type="text" appInput readonly [value]="getQuadrantDisplayValue()">
  </app-input-group>

  <app-input-group>
    <label class="ec-toggle-label">
      {{ 'meteringpoint.meter.sendTimeSeries' | translate }}
      <app-toggle formControlName="sendMeterReadings"></app-toggle>
    </label>
  </app-input-group>

</form>
